export const EMPLOYEE_LIST_PATH = "/settings?menu=employee";
export const EMPLOYEE_NEW_PATH = "/settings/employees/new";
export const employeeDetailsPath = (id) => `/settings/employees/${id}`;
export const employeeEditPath = (id) => `/settings/employees/${id}/edit`;

export const getEmployeeFullName = (employee) =>
    [employee?.firstName, employee?.lastName].filter(Boolean).join(" ").trim();

export const getEmployeeInitials = (employee) =>
    [employee?.firstName, employee?.lastName]
        .filter(Boolean)
        .map((part) => part.trim()[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();

export const isEmployeeActive = (employee) => employee?.status === "active";

const toFieldName = (path) => (path?.includes(".") ? path.split(".") : path);

/** Puts API validation errors next to the fields they belong to. Returns true if any were applied. */
export const applyValidationFieldErrors = (form, errorSources) => {
    const fieldErrors = (errorSources || []).filter((source) => source.path);
    if (fieldErrors.length === 0) return false;

    form.setFields(fieldErrors.map((source) => ({ name: toFieldName(source.path), errors: [source.message] })));
    return true;
};

export const getEmployeeErrorMessage = ({ message, errorSources }, t) => {
    if (message === "Mongoose Duplicate Error") {
        const emailError = errorSources?.find((source) => source.path === "email");
        return emailError?.message || t("employees.emailAlreadyExists");
    }
    return message || t("employees.errorSubmittingForm");
};
